import { MailIcon } from 'zudoku/icons';

/** Left block of the footer: the mark, one line on what this site is, and the support address. */
export const FooterBrand = () => (
  <div className="noe-footer-brand hidden md:flex flex-col gap-4 max-w-xs shrink-0 me-auto">
    <img src="/noe-logo.png" alt="Noé" className="w-16 dark:hidden" loading="lazy" />
    <img src="/noe-logo-dark.png" alt="Noé" className="w-16 hidden dark:block" loading="lazy" />
    <p className="text-sm text-muted-foreground leading-relaxed m-0">
      Le logiciel des conciergeries : réservations, ménage, paiements et site de réservation
      directe, au même endroit.
    </p>
    <a
      href="mailto:support@wearenoe.fr"
      className="inline-flex items-center gap-2 text-sm font-medium text-foreground hover:text-primary"
    >
      <MailIcon size={15} aria-hidden="true" />
      support@wearenoe.fr
    </a>
  </div>
);
